import { LinkTab, LinkTabs } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router";
import styled from "styled-components";
import { EventUserRequestApprovedList } from "./approved/EventUserRequestApprovedList";
import { EventUserRequestOpenList } from "./open/EventUserRequestOpenList";

const Wrapper = styled.div`
	display: grid;
	gap: 1.5rem;
	padding-bottom: 1.5rem;
	align-items: start;
`;

export const EventUserRequestPage: FC = () => {
	const { t } = useTranslation();

	return (
		<Wrapper>
			<LinkTabs>
				<LinkTab to="../requests/open">{t("Open requests")}</LinkTab>
				<LinkTab to="../requests/approved">{t("Approved requests")}</LinkTab>
			</LinkTabs>

			<Routes>
				<Route path="open" element={<EventUserRequestOpenList />} />
				<Route path="approved" element={<EventUserRequestApprovedList />} />
			</Routes>
		</Wrapper>
	);
};
